import type { AssistantMode } from '@/stores/use-ui-store';

/**
 * Whether the floating "Ask Nula" bar should be visible.
 *
 * The bar shows only in `collapsed` mode, and never while the focused tab is
 * itself a conversation/chat — in that case the assistant already occupies the
 * whole tab, so a floating bar over it would be redundant.
 */
export function shouldShowAssistantBar(
  mode: AssistantMode,
  activeTabIsConversation: boolean,
): boolean {
  return mode === 'collapsed' && !activeTabIsConversation;
}
